import React from "react";

const Youtube = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5887 7.04508C21 8.64887 21 11.9969 21 11.9969C21 11.9969 21 15.3449 20.5887 16.9487C20.3601 17.8352 19.6914 18.5327 18.8445 18.7685C17.3064 19.1969 12 19.1969 12 19.1969C12 19.1969 6.6963 19.1969 5.1555 18.7685C4.305 18.5291 3.6372 17.8325 3.4113 16.9487C3 15.3449 3 11.9969 3 11.9969C3 11.9969 3 8.64887 3.4113 7.04508C3.6399 6.15858 4.3086 5.46107 5.1555 5.22527C6.6963 4.79687 12 4.79688 12 4.79688C12 4.79688 17.3064 4.79687 18.8445 5.22527C19.695 5.46467 20.3628 6.16128 20.5887 7.04508ZM10.2 15.1469L15.6 11.9969L10.2 8.84687V15.1469Z"
        fill="#DDF3F6"
      />
    </svg>
  );
};

export default Youtube;
